import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DateRangeProvider } from './context/DateRangeContext';
import { DepositProvider } from './context/DepositContext';
import Routes from './Routes'; // Adjusted to import Routes from a separate file


const App = () => {
  return (
    <AuthProvider>
      <DateRangeProvider>
        <DepositProvider> 
          <Router>
            <Routes />
          </Router>
        </DepositProvider>
      </DateRangeProvider>
    </AuthProvider>
  );
};

export default App;